import "./index.css";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";
import React from "react";
import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

import { environment } from "~/environment";
import { initializeAdsProvider, ToastPortal } from "~/ui/components";
import { useToastState } from "~/ui/context";
import { PremiumModalContextProvider } from "~/ui/context/premiumModalContext";

import { App } from "./App";
import { LanguageContextProvider } from "./ui/context/language";

const client = new QueryClient({
  defaultOptions: {
    mutations: {
      onError: useToastState.getState().handleError,
    },
    queries: {
      cacheTime: 60 * 1000,
      staleTime: 2 * 60 * 100,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  },
});

const stripe = loadStripe(environment.STRIPE_KEY);

initializeAdsProvider();

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={client}>
      <LanguageContextProvider>
        <PremiumModalContextProvider>
          <HelmetProvider>
            <Elements stripe={stripe}>
              <App />
              <ToastPortal />
            </Elements>
          </HelmetProvider>
        </PremiumModalContextProvider>
      </LanguageContextProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>,

  document.getElementById("root")
);

if (import.meta.hot) {
  import.meta.hot.accept();
}
